const themes = [
    "monokai",
    "dracula",
    "material-ocean",
    "blackboard",
    "yeti"
]

export default themes